var _defs, _g, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 64,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.75,
    y1: 29.91,
    x2: 37.25,
    y2: 48.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f30909"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 39,
    r: 10.5,
    stroke: "#f30909",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,22.71V16.5m0,45V55.29M43.52,27.48l4.39-4.39M16.09,54.91l4.39-4.39m0-23-4.39-4.39M47.91,54.91l-4.39-4.39M15.71,39H9.5m45,0H48.29",
    fill: "none",
    stroke: "#f30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 32 39; 360 32 39",
    dur: "45s",
    repeatCount: "indefinite"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "16 42.5 27 42.5 32 47 37 42.5 48 42.5",
    fill: "none",
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.e8906c840da312f13658b23f556cf6d9.svg";
export { ForwardRef as ReactComponent };